import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

//imagens del carrosel

const images = [
  { id: 1, src: "images/carousel/cats1.png", alt: "Gatos" },
  { id: 2, src: "images/carousel/cats2.png", alt: "Gatos2" },
  { id: 3, src: "images/carousel/cats3.png", alt: "Gatos3" },
  { id: 4, src: "images/carousel/cats4.png", alt: "Gatos4" },
  { id: 5, src: "images/carousel/cats5.png", alt: "Gatos5" },
  { id: 6, src: "images/carousel/cats6.png", alt: "Gatos6" },
];

function AboutUs() {
  return (
    <Box>
      {/* Móduclo Banner */}
      <Box sx={{ width: "100%", height: "45vh", overflow: "hidden" }}>
        <img src="/images/banner1.png" alt="BisbalGat Banner" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
      </Box>

      <br></br>
      <br></br>

      
      <Container maxWidth="lg" sx={{ paddingLeft: "100px"}}>
        {/* Módulo Informaciones */}
        <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: "bold", color: "#383838"}}>
            Presentació de l’Associació Bisbalgat
        </Typography>
        <Typography variant="body1" align="center" gutterBottom sx={{ fontSize: '14px' }}>
        L’Associació Bisbalgat és una associació sense ànim de lucre, reconeguda per la Generalitat de Catalunya l’any 2011. 
        <br/>Neix degut a la necessitat de controlar les colònies de gats de la Bisbal d’Empordà, Girona, obligació dels ajuntaments per la llei 2/2008 art. 16 i 17 de la protecció dels animals. <br/>
        Aquest mateix any, 2011, la direcció de l’associació, arriba a un acord amb l’ajuntament de la Bisbal i signen un conveni per a procedir a fer les captures dels gats de carrer amb l’objectiu de controlar la natalitat dels gats de les colònies aplicant el mètode C.E.R. (Captura Esterilització i Retorn a la colònia). <br/>
        En els cinc primers anys de la constitució de l’associació i gràcies al conveni amb l’ajuntament, les 35 colònies existents a la població queden controlades en un 99% però amb els abandonaments cada vegada més massius i els gats que es perden que els seus “responsables” no busquen, la població felina a la ciutat, cada any, es veu augmentada. <br/>
        I cada vegada es veu més desbordada de gats, doncs hi ha més naixements i més gats morts atropellats en via pública. És per aquesta deixadesa que comencen els enverinaments massius per part dels veïns molestats pel descontrol donant una imatge deplorable de població incívica. <br/>
        És a partir de l’any 2016 quan la Marta López Leal, l’actual presidenta de l’associació, agafa la direcció donant un canvi radical al què havien portat a terme fins aleshores amb l’ajuntament, doncs es veuen desbordades de gats carinyosos perduts/ abandonats i es troben amb la necessitat de treure’ls dels carrers per tal de protegir-los i donar-los la vida digna que es mereixen com a sers vius ja que els gats domèstics carinyosos no es poden valdra per sí mateixos i en el carrer no sobreviuen o malviuen. <br/>
        D’aquesta manera, l’ajuntament agafa les rendes del control de colònies pel seu compte, l’associació captura els gats carinyosos perduts/ abandonats dels carrers i els porten al veterinari per facilitar l’atenció veterinària necessària. <br/>
        També ajuden als gats ferals malalts, ferits i als gats nascuts al carrer que capturen juntament amb les seves mares per facilitar la lactància i donar-los l’atenció veterinària necessària. <br/>
        D’aquesta manera, els objectius de l’associació canvien degut a la necessitat del moment pel gran nombre de gats carinyosos que hi ha en via pública i es dóna d’urgència prioritària rescatar-los, donar-los en adopció responsable o buscar una casa d’acollida per una vida felina digna i una imatge de població civilitzada.
        </Typography>
      </Container>

      <br></br>

      <br/>

      {/* Módulo Carrosel */}
      <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: "bold", color: "#383838"}}>
            Antes y después de algunos gatos rescatados por Bisbalgat
      </Typography>
      <Box sx={{ maxWidth: "800px", margin: "0 auto", my: 4 }}>
        <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          spaceBetween={30}
          slidesPerView={1}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          navigation
          loop
          style={{ 
            width: "100%", 
            height: "300px", // Altura reduzida
          }}
        >
          {images.map((image) => (
            <SwiperSlide key={image.id}>
              <Box
                component="img"
                src={image.src}
                alt={image.alt}
                sx={{
                  width: "100%",
                  height: "300px", // Altura reduzida
                  objectFit: "cover",
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>

      

      




    </Box>
  );
}

export default AboutUs;
